<template>
<article class="about" id="step1">
      <!--海报-->
      <section class="banner container-fluid">
            <img src="../../../static/img/about-bg.jpg" alt="">
            <div class="title">
              <p class="p1">关于我们</p>
              <p class="p2">迪果 2008 年成立于上海，16年持续稳健发展，根基扎实。</p>
              <p class="p2">双研发中心布局上海与西安，业务覆盖全球，海外发行品牌<span class="cont-big">BIG</span><span class="cont-cake">CAKE</span>与<span class="cont-6677g">6677g</span>享誉市场。</p>
              <p class="p2">我们集游戏研发、运营、发行为一体，专注打造全球性休闲手游精品。</p>
            </div>
      </section>
      <!--列表介绍-->
      <section class="info-list">
          <div class="container-fluid">
            <div class="item  bx">
                  <div class="font">
                    <div>
                      <div class="title">产品与成绩</div>
                      <p class="list-info-row">我们的业务覆盖消除游戏、纸牌游戏、益智游戏等众多休闲游戏品类</p>
                      <p class="list-info-row">代表作Daily Mahjong Match，2025年首发即达千万+下载，长期处于榜单前三</p>
                      <p class="list-info-row">经典作Daily Number Match，累计下载千万+，位于榜单前10</p>
                      <p class="list-info-row">经典作Spider Solitaire，累计下载千万+，长期霸榜8年+</p>
                      <p class="list-info-row">我们是Google、Facebook 、亚马逊的战略合作伙伴，产品风靡欧美并多次进入美国游戏下载榜前10，目前游戏总下载数量超过3.5亿次。</p>
                    </div>
                  </div>
                  <div class="img">
                      <img src="../../../static/img/about-list1.png" alt="">
                  </div>
            </div>
          </div>
          <div class="container-fluid" style="background:#fff;">
            <div class="item  bx">
                  <div class="img">
                      <img src="../../../static/img/about-list2.png" alt="">
                  </div>
                  <div class="font">
                    <div>
                      <div class="title">我们的团队</div>
                      <p class="list-info-row">迪果目前已经汇聚了众多来自国内外顶级学府的一流人才，许多核心成员均来自知名互联网公司及游戏公司，组成了优秀的游戏团队。</p>
                      <p class="list-info-row">我们始终坚信只有优秀人才才能打造出优秀的产品，如果你拥有超强自驱力、务实踏实、结果导向、追求卓越，我们期待你的加入，与志同道合的伙伴们一起，打造出更多头部产品。</p>
                    </div>
                  </div>
            </div>
          </div>
          <div class="container-fluid">
            <div class="item  bx">
                  <div class="font">
                    <div>
                      <div class="title">我们的愿景</div>
                      <p class="list-info-row">坚持 “每款游戏让用户玩十年以上” 的产品初心，拒绝短视，打磨长线精品。</p>
                      <p class="list-info-row">我们秉持 “长期主义、追求更好” 的理念，目标成为全球顶尖的休闲游戏公司！</p>
                    </div>
                  </div>
                  <div class="img">
                      <img src="../../../static/img/about-list3.png" alt="">
                  </div>
            </div>
          </div>
      </section>
      <!--办公环境-->
      <section class="office">
          <div class="title">办公环境</div>
          <div class="photo"><img src="../../../static/img/office.jpg" alt=""></div>
      </section>
   <!--地址-->
</article>

</template>

<script>
  export default {
    name: 'join-us',
    data() {
      return {
        activeIndex: 0,
        invite:{
          first_card:{
            sketch:[],
            particulars:[]
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .about {
    max-width:1920px;
    margin:0 auto;
    .orange {
      color: #ff9d01;
    }
    // 海报
    .banner {
      padding:0;
      position: relative;
      background-color: #2b292a;
      img {
        display:block;
        margin:0 auto;
        max-width:1920px;
      }
      .title {
        position: absolute;
        // text-align: center;
        top:50%;
        left:40%;
        transform:translate(-50%,-50%);
        color:#fff;
        font-size:38px;
        .p1 {
            color: #666;
            font-weight: bold;
            font-size: 35px;
        }
        .p2 {
          font-size:18px;
          line-height: 36px;
        }
        .cont-big {
            margin-left: 5px;
            color: #b3dff6;
            font-weight: bold;
        }
        .cont-cake {
            margin-right: 5px;
            color: #fcb075;
            font-weight: bold;
        }
        .cont-6677g {
            color: #bdf5b9;
            font-weight: bold;
            margin-left: 5px;
            margin-right: 5px;
        }
        @media screen and (max-width:767px){
          font-size:4vw;
          .p2 {
            font-size:2.8vw;
            line-height: 3.2vh;
          }
        }
       }
    }
      .container-fluid {
         min-height: 265px;
      }
    // 详情列表
    .info-list {
      &>.container-fluid {
         background-color: #f6f6f6;
      }
      .item {
          display:flex;-webkit-display:flex;-moz-display:flex;-o-display:flex;
          box-sizing: border-box;
          min-height:600px;
          align-items:center;
          .font { 
            height:100%;
            padding:25px;
            color:#6d6d6d;
            .title {
              font-size:25px;
              padding-bottom:22px;
              color:#474747;
              font-weight:700;
              &:after {
                 display:block;
                 content:'';
                 height:3px;
                 width:70px;
                 background-color: #ff9c26;
                 margin-top:12px;
              }

            }

          }
          .img {
            padding:5%;
            padding-left:0;
          }
          &>div {
            flex:1;
          }
          // 适配ipad
          @media screen and (min-width:500px) and (max-width:992px){
              min-height:300px;
          }
          // 适配手机
          @media screen and (max-width:500px){
              min-height:400px;
              flex-wrap:wrap;
              &>div {
                flex-basis:100%;
                width:100%;
              }
              .img {
                padding:0 12% 5%;
              }
              .font {
                padding:5%;
                font-size:12px;
                .title {
                  font-size:17px;
                }
              }
          }
          .list-info-row {
              // color: red;
              line-height: 32px;
              font-size: larger;
          }
      }
    }
    // 办公环境
    .office {
            .title {
              margin:0 auto;
              text-align: center;
              max-width:414px;
              font-size:20px;
              font-weight:700;
              height:110px;
              line-height: 110px;
              // padding-bottom:22px;
              color:#474747;
              &:after {
                 margin:0 auto;
                 display:block;
                 content:'';
                 height:3px;
                 width:70px;
                 background-color: #ff9c26;
                 margin-top:-28px;
              }

            }
            .photo {
              margin-bottom:20px;
            }
    }

    .address {
      background-color: #aaa;
      position: relative;
      .map {
        height:510px;
        background-color: yellow;
        width:100%;
          .address-info {
            text-align: left;
            z-index:9999;
            overflow: hidden;
              .txt-box {
                max-width:370px;
                height:315px;
                background-color: #ffffff;
                margin-top:50px;
                padding:44px;
                // padding-top:28px;
                h2 {
                  font-size:22px;
                  height:60px;
                  line-height: 60px;
                  margin-bottom:14px;
                  &:after {
                    content:'';
                    display:block;
                    height:3px;
                    width:50px;
                    background-color: #ff9b25;
                  }
                }
                p {
                  font-size:13px;
                  height:30px;
                  line-height: 30px;
                  color:#989898;
                  i.email {
                    margin-right:2px;
                  }
                  i {
                    color:#ff9b25;
                    margin-right:5px;
                  }
                }
              }
          }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/about.vue